import axios from 'axios';
import {getJwtToken} from 'utils/auth/getSession';

import NodeCache from 'node-cache';
const myCache = new NodeCache();

export class Backend {
  async get(path, cache = false, responseType = 'json') {
    let value = cache ? myCache.get(`${path}`) : undefined;
    if ( value == undefined ) {
      const output = await callBackEnd(path, 'GET', null, responseType);
      myCache.set(`${path}`, output, 300 );
      value = output;
    }
    return value;
  }

  post(path, body) {
    return callBackEnd(path, 'POST', body);
  }

  put(path, body) {
    return callBackEnd(path, 'PUT', body);
  }

  delete(path, body) {
    return callBackEnd(path, 'DELETE', body);
  }
}

export const IDENTITY_API = process.env.REACT_APP_IDENTITY_API;
export const CAREGIVER_API = process.env.REACT_APP_CAREGIVER_API;
export const CLIENT_LEAD_API = process.env.REACT_APP_CLIENT_LEAD_API;
export const CLIENT_SUPPORT_API = process.env.REACT_APP_CLIENT_SUPPORT_API;
export const CLIENT_API = process.env.REACT_APP_CLIENT_API;
export const SCHEDULE_API = process.env.REACT_APP_SCHEDULE_API;
export const PAYMENT_API = process.env.REACT_APP_PAYMENT_API;
export const FILE_STORAGE_API = process.env.REACT_APP_FILE_STORAGE_API;
export const JOB_API = process.env.REACT_APP_JOB_API;
export const METRICS_API = process.env.REACT_APP_METRICS_API;
export const NOTIFICATION_API = process.env.REACT_APP_NOTIFICATION_API;
export const COMMUNICATION_API = process.env.REACT_APP_COMMUNICATION_API;
export const DIALPAD_INTEGRATION_API = process.env.REACT_APP_DIALPAD_INTEGRATION_API;
export const WORKFLOW_ENGINE_API = process.env.REACT_APP_WORKFLOW_ENGINE_API;
export const AGENTCORE_ENGINE_API = process.env.REACT_APP_AGENTCORE_ENGINE_API;

export default new Backend();

const callBackEnd = async (url, requestMethods, body, responseType) => {
  try {
    const token = await getJwtToken();
    const result = await axios({
      method: requestMethods,
      url: url,
      data: body,
      headers: {'X-Auth': token},
      responseType,
    });
    return result.data;
  } catch (error) {
    if (error?.response?.data) {
      // Request made and server responded
      console.error(`Error calling ${url}. Code returned ${error.response.status} and message ${error.response.data.message}`);
      throw error.response.data;
    } else {
      // Something happened in setting up the request that triggered an Error
      console.error(error.request, error.message);
    }
    throw new Error(`Error calling ${url}.`, error);
  }
};
